import type { ReactNode } from 'react'
import type { SiteSection } from '@/types'

import { SectionHeading } from '@/components/site/section-heading'

interface PageHeroProps {
    section: SiteSection | null | undefined
    children?: ReactNode
}

// Dark navy banner used at the top of every inner page.
export const PageHero = ({ section, children }: PageHeroProps) => (
    <section id='page-hero' className='relative overflow-hidden bg-navy-950'>
        <div aria-hidden='true' className='pointer-events-none absolute -top-32 -left-24 size-[26rem] rounded-full bg-emerald-700/25 blur-3xl' />
        <div aria-hidden='true' className='pointer-events-none absolute -right-20 -bottom-40 size-[24rem] rounded-full bg-gold-500/15 blur-3xl' />
        <div aria-hidden='true' className='absolute inset-0 opacity-[0.07] [background-image:radial-gradient(#E0C68E_1px,transparent_1px)] [background-size:22px_22px]' />

        <div className='relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8'>
            <SectionHeading section={section} tone='dark' as='h1' />
            {children && <div className='mt-10'>{children}</div>}
        </div>
    </section>
)
